import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useRoles, type AppRole } from "@/hooks/useRoles";

export function RoleProtectedRoute({
  role,
  children,
}: {
  role: AppRole;
  children: JSX.Element;
}) {
  const { user, loading: authLoading } = useAuth();
  const { roles, loading } = useRoles();
  if (authLoading || loading) {
    return <div className="p-8 text-sm text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/auth" replace />;
  const allowed = roles?.includes(role) || roles?.includes("admin");
  if (!allowed) return <Navigate to="/" replace />;
  return children;
}